import { render } from "./ArtimberLogo.vue?vue&type=template&id=db580d46"
import script from "./ArtimberLogo.vue?vue&type=script&lang=js"
export * from "./ArtimberLogo.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__